import { ChangeDetectionStrategy, Component } from "@angular/core";
import { BASE_PUBLIC_ASSETS_URL } from "@dtm-frontend/shared/utils";

interface KpoFile {
    name: string;
    url: string;
}

const POPULATION_DENSITY_FILE: KpoFile = {
    name: "Plik do Instrukcji - Zagęszczenie Gmin Analiza.zip (470 MB)",
    url: `${BASE_PUBLIC_ASSETS_URL}/Plik_do_Zalacznika_7_Zageszczenie_Gmin_Analiza.zip`,
};

const COMPETITION_AREA_FILE = {
    name: "Plik - strefy PL - konkurs CK.zip (1MB)",
    url: `${BASE_PUBLIC_ASSETS_URL}/strefy_PL_konkurs_CK.zip`,
};

const COMPETITION_AREA_INSTRUCTIONS_FILE = {
    name: "Instrukcja korzystania z pliku - strefy PL - konkurs CK.kml",
    url: `${BASE_PUBLIC_ASSETS_URL}/Instrukcja_do_pliku_-_strefy_PL_-_konkurs_CK.kml.pdf`,
};

const ALL_COMPETITION_FILES: KpoFile[] = [
    {
        name: "Regulamin wraz z załącznikami 1 – 9 (1,5 MB)",
        url: `${BASE_PUBLIC_ASSETS_URL}/Regulamin_i_zalaczniki.zip`,
    },
    COMPETITION_AREA_FILE,
    COMPETITION_AREA_INSTRUCTIONS_FILE,
    POPULATION_DENSITY_FILE,
    {
        name: "Komunikat z dnia 15.04.2025r.pdf",
        url: `${BASE_PUBLIC_ASSETS_URL}/Komunikat_z_dnia_15_04_2025r.pdf`,
    },
];
const KPO_BASE_FILES: KpoFile[] = [
    {
        name: "Regulamin konkursu",
        url: `${BASE_PUBLIC_ASSETS_URL}/Regulamin_Konkursu_na_wybór_9_obszarów_CK.pdf`,
    },
    {
        name: "Harmonogram przebiegu Konkursu (Załącznik nr 3)",
        url: `${BASE_PUBLIC_ASSETS_URL}/Załącznik_nr_3_Harmonogram_Konkursu.pdf`,
    },
    {
        name: "Wzór Umowy o współpracy (Załącznik nr 6)",
        url: `${BASE_PUBLIC_ASSETS_URL}/Załącznik_nr_6_Umowa_o_współpracy.pdf`,
    },
];

const FIRST_PHASE_FILES: KpoFile[] = [
    {
        name: "Wzór Wstępnego Wniosku – Etap 1 (Załącznik nr 1)",
        url: `${BASE_PUBLIC_ASSETS_URL}/Załącznik_nr_1_Wstępny_Wniosek.docx`,
    },
    {
        name: "Kryteria oceny Wstępnych Wniosków – Etap 1 (Załącznik nr 4)",
        url: `${BASE_PUBLIC_ASSETS_URL}/Załącznik_nr_4_Kryteria_oceny_Wstępnych_Wniosków.pdf`,
    },
];
const SECOND_PHASE_FILES: KpoFile[] = [
    {
        name: "Wzór Wniosku – Etap 2 (Załącznik nr 2)",
        url: `${BASE_PUBLIC_ASSETS_URL}/Załącznik_nr_2_Wniosek.docx`,
    },
    {
        name: "Kryteria oceny Wniosków – Etap 2 (Załącznik nr 5)",
        url: `${BASE_PUBLIC_ASSETS_URL}/Załącznik_nr_5_Kryteria_oceny_Wniosków.pdf`,
    },
];
const OWN_ANALYSIS_FILES: KpoFile[] = [
    COMPETITION_AREA_FILE,
    COMPETITION_AREA_INSTRUCTIONS_FILE,
    {
        name: "Instrukcja korzystania z modelu do analizy zagęszczenia ludności i lokalizacji obszaru (Załącznik nr 7)",
        url: `${BASE_PUBLIC_ASSETS_URL}/Załącznik_nr_7_Instrukcja_korzystania_z_modelu.pdf`,
    },
    POPULATION_DENSITY_FILE,
];
const TRAINING_CENTERS_FILES: KpoFile[] = [
    {
        name: "Informacja dodatkowa dot. organizacji Ośrodków w ramach CK (Załącznik nr 8)",
        url: `${BASE_PUBLIC_ASSETS_URL}/Załącznik_nr_8_Informacja_dodatkowa_dot._organizacji_Ośrodków_w_ramach_CK.pdf`,
    },
    {
        name: "Wzór zgłoszenia lokalizacji na potrzeby utworzenia Ośrodka (Załącznik nr 9)",
        url: `${BASE_PUBLIC_ASSETS_URL}/Załącznik_nr_9_Wzór_zgłoszenia_lokalizacji_na_potrzeby_utworzenia_Ośrodka.docx`,
    },
];

@Component({
    selector: "dtm-main-page-lib-kpo-files",
    templateUrl: "./kpo-files.component.html",
    styleUrls: ["./kpo-files.component.scss"],
    changeDetection: ChangeDetectionStrategy.OnPush,
})
export class KpoFilesComponent {
    protected readonly ALL_COMPETITION_FILES = ALL_COMPETITION_FILES;
    protected readonly KPO_BASE_FILES = KPO_BASE_FILES;
    protected readonly FIRST_PHASE_FILES = FIRST_PHASE_FILES;
    protected readonly SECOND_PHASE_FILES = SECOND_PHASE_FILES;
    protected readonly OWN_ANALYSIS_FILES = OWN_ANALYSIS_FILES;
    protected readonly TRAINING_CENTERS_FILES = TRAINING_CENTERS_FILES;
}
